var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveSegmentEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 14,
    viewBox: "0 0 47 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.442 10.43C42.3363 11.5666 44.7934 10.9523 45.93 9.05798C47.0666 7.16366 46.4523 4.70662 44.558 3.57003L40.442 10.43ZM22.5 7L24.558 10.43C29.4464 7.49689 35.5535 7.49689 40.442 10.43L42.5 7L44.558 3.57003C37.1361 -0.883127 27.8639 -0.883127 20.442 3.57003L22.5 7ZM22.5 7L20.442 3.57003C15.5535 6.50311 9.44645 6.50311 4.55798 3.57003L2.5 7L0.442016 10.43C7.86394 14.8831 17.1361 14.8831 24.558 10.43L22.5 7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveSegmentEnd);
export default __webpack_public_path__ + "static/media/waveSegmentEnd.ffe5abf48547c72a257e57691d4a956e.svg";
export { ForwardRef as ReactComponent };